import type { FaireProductEntity } from "../../entity_types/product";

export const p_7wz5cxy6i0: FaireProductEntity = {
  token: "p_7wz5cxy6i0",
  type: "product",
  name: "Chubby Heart Chunky Notepad",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/72bb91dfe4ef26882f954ec868e5248b5c07f0658ded4be40b68225a0dcabbcf.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/338a7321b0caf44bc3c253af87f72b53f0bec74d5fbe91348e9a95a9b80bae30.jpeg",
    "https://cdn.faire.com/fastly/c8c885d41b1115d57d26a3bdff748645e5b044a22b9132ef20c5e873b167a126.jpeg",
    "https://cdn.faire.com/fastly/08fc1d62962290996502ff5609da234cb23c7a4344cbf5676b6ce87d705f8115.png",
  ],
  priceDollars: 9,
  description:
    "Big and chunky. It's how we like our desserts and this awesome square notepad. This is the guy you pull out when you need an extra sturdy surface for those big, chunky ideas.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:50.949Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
